module.exports = __webpack_public_path__ + "static/media/boat-battle.f27711ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/boat-battle.png
// module id = 1286
// module chunks = 0